import { useTranslation } from 'next-i18next'

export interface BootcampLevelPickerProps {
  levels: number[]
  value: number
  onChange: (level: number) => void
}

export function BootcampLevelPicker({ levels, value, onChange }: BootcampLevelPickerProps): React.ReactElement {
  const { t } = useTranslation('bootcamp')

  return (
    <div>
      {levels.map((level) => (
        <a
          className={`rounded shadow  px-2 mx-2 ${level !== value ? 'text-purple bg-white' : 'text-white bg-purple'}`}
          href="#"
          key={level}
          onClick={(evt) => {
            evt.preventDefault()
            onChange(level)
          }}
        >
          {t('level')} {level}
        </a>
      ))}
    </div>
  )
}
